module.exports = __webpack_public_path__ + "static/smokewagon-1df398a6312716e6e68c2dc9ead517db.jpg";